import React from 'react'

import { Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { dndStateProps, WeekObject } from '../PostCalendar'
import CalendarDay from './CalendarDay'
import { CalendarDateParams, DateObject } from '../ProfessocialCalendar'
import { AboType } from '@3m5/sm_publish-frontend-api'

interface IProps {
  index: number
  week: WeekObject
  selectedDate?: number
  calendarData?: DateObject
  changeCalendarData?: (data: DateObject) => void
  changeSelectedDate?: (date: number) => void
  editSettings?: (topicId: string | undefined, aboType: AboType) => void
  changeDataParams?: (params: CalendarDateParams) => void
  setSelectedDate?: (selectedDate: number) => void
  dragAndDrop: dndStateProps
  handleDnD: (data: dndStateProps) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  calendarDaysRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #f5f5f5',
  },
}))

const CalendarWeek: React.FC<IProps> = ({ week, index, ...props }) => {
  const classes = useStyles()

  return (
    <Box key={index} className={classes.calendarDaysRow} component='div'>
      {week.days.map((day, i) => {
        return (
          <CalendarDay
            key={i}
            index={i}
            day={day}
            calendarData={props.calendarData}
            editSettings={props.editSettings}
            setSelectedDate={props.setSelectedDate}
            changeCalendarData={props.changeCalendarData}
            dragAndDrop={props.dragAndDrop}
            onHandleDnD={props.handleDnD}
          />
        )
      })}
    </Box>
  )
}

export default CalendarWeek
